import styled from 'styled-components';
import { Button } from 'antd';
import { defaultTheme } from '@nxsys/constants/defaultConfig';

export const StyledButton = styled(Button)`
  padding: 10px 20px;
  gap: 6px;

  .ant-btn-icon {
    width: 20px;
    height: 20px;
  }

  &.ant-btn-variant-outlined,
  &.btn-add-new {
    background: ${defaultTheme.theme.palette.white};
    color: ${defaultTheme.theme.palette.text.secondary};
    border-color: ${defaultTheme.theme.palette.secondary.main};

    .ant-btn-icon svg {
      color: ${defaultTheme.theme.palette.text.secondary};
      fill: ${defaultTheme.theme.palette.text.secondary};
    }
    &:disabled {
      color: ${defaultTheme.theme.palette.text.disabled} !important;
      border-color: ${defaultTheme.theme.palette.text.disabled} !important;
      .ant-btn-icon svg {
        color: ${defaultTheme.theme.palette.text.disabled} !important;
        fill: ${defaultTheme.theme.palette.text.disabled} !important;
      }
    }
  }
  &.ant-btn-variant-solid {
    color: ${defaultTheme.theme.palette.white};
    border-color: ${defaultTheme.theme.palette.secondary.main};

    .ant-btn-icon svg {
      color: ${defaultTheme.theme.palette.white};
      fill: ${defaultTheme.theme.palette.white};
    }
    &:hover,
    &:focus,
    &:active {
      background: ${defaultTheme.theme.palette.secondary.main} !important;
      color: ${defaultTheme.theme.palette.white} !important;
      border-color: ${defaultTheme.theme.palette.secondary.main} !important;

      .ant-btn-icon svg {
        color: ${defaultTheme.theme.palette.white} !important;
        fill: ${defaultTheme.theme.palette.white} !important;
      }
    }
    &:disabled {
      color: ${defaultTheme.theme.palette.text.disabled} !important;
      border-color: ${defaultTheme.theme.palette.text.disabled} !important;
      background: ${defaultTheme.theme.button.disabled.background} !important;
      .ant-btn-icon svg path {
        color: ${defaultTheme.theme.palette.text.disabled} !important;
        fill: ${defaultTheme.theme.palette.text.disabled} !important;
      }
    }
  }
  &.btn-add-new,
  &.ant-btn-variant-outlined {
    &:hover,
    &:focus,
    &:active {
      background: ${defaultTheme.theme.palette.white} !important;
      color: ${defaultTheme.theme.palette.text.secondary} !important;
      border-color: ${defaultTheme.theme.palette.secondary.main} !important;

      .ant-btn-icon svg {
        color: ${defaultTheme.theme.palette.text.secondary} !important;
        fill: ${defaultTheme.theme.palette.text.secondary} !important;
      }
    }
    &:focus-visible {
      outline: none;
      box-shadow: none;
    }
    &:disabled {
      color: ${defaultTheme.theme.palette.text.disabled} !important;
    }
  }
  &.btn-delete {
    background: ${defaultTheme.theme.palette.white};
    color: rgba(240, 68, 56, 1);
    border-color: rgba(240, 68, 56, 1);

    .ant-btn-icon svg {
      color: rgba(240, 68, 56, 1);
      fill: rgba(240, 68, 56, 1);
    }
    &:hover,
    &:focus,
    &:active {
      background: ${defaultTheme.theme.palette.white};
      color: rgba(240, 68, 56, 1) !important;
      border-color: rgba(240, 68, 56, 1) !important;

      .ant-btn-icon svg {
        color: rgba(240, 68, 56, 1) !important;
        fill: rgba(240, 68, 56, 1) !important;
      }
    }
  }
  img {
    width: 16px;
    height: 16px;
  }
  .anticon {
    font-size: 16px;
  }
`;
